import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
import ContentHeader from '../components/ContentHeader';
import ViewTicketButtons from '../components/ViewTicketButtons';
import ButtonLink from '../components/ButtonLink';

const styles = theme => ({
    root: {
        textAlign: 'center',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    heading: {
        marginBottom: '10px'
    },
    subheading: {
        marginTop: '20px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    inner: {
        padding: '20px 10px'
    },
    button: {
        margin: '5px 5px'
    }
});

const BookingConfirmed = ({ classes, match }) => {
    const {
        params: { customerTicketId }
    } = match;

    return (
        <div className={classes.root}>
            <ContentHeader
                text="Booking Confirmed"
                id="order-confirmed-heading"
            />
            <div className={classes.inner}>
                <Typography className={classes.paragraph} variant="body2">
                    Congratulations, your order was successful and your advance
                    pass is ready to use.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    Passes will be scanned on board and will need to be
                    presented by the passenger.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    You can book more trips on your advance pass from the &quot;
                    My Tickets&quot; area.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    <ButtonLink
                        className={classes.button}
                        variant="outlined"
                        color="primary"
                        to={`/book/${customerTicketId}/`}
                    >
                        Book more trips
                    </ButtonLink>
                </Typography>

                <ViewTicketButtons ticketId={customerTicketId} />
            </div>
        </div>
    );
};

export default withStyles(styles)(BookingConfirmed);
